// extracted by mini-css-extract-plugin
module.exports = {"list":"ProjectParticipiantsModalPeopleList_list__dw8Kx"};